import { TranslatedText } from "@/components/common/text";
import { getLoadId } from "@/utils/load";
import { LoadboardToggleRow, LoadboardModal, LoadCounterOfferPanel } from "@/components/dataPages/loadboard";
import { Table, TableBody } from "@/components/common/table/table";

export const LoadViewDetailsModal = ({ offer, open, onOpenChange }) => {
    const loadId = getLoadId(offer.loadBoardItem.uniqueId);
    const isCountered = offer.status === "COUNTERED";

    return (
        <LoadboardModal
            title={
                <div>
                    <TranslatedText>Load ID</TranslatedText> {loadId}
                </div>
            }
            open={open}
            onOpenChange={onOpenChange}
            usePortal={false}
            contentClassName="w-full max-w-[1440px] h-[418px]"
            buttonClassName="text-cm-p-text-primary font-medium text-sm/[22px]"
            buttonChildren={<TranslatedText text="View details" />}
        >
            <div className="flex flex-col w-[calc(100%+2rem)] bg-cm-p-background -mt-3 -mx-4 -mb-4 max-w-[1440px]">
                <Table className="w-full">
                    <TableBody>
                        <LoadboardToggleRow
                            load={offer.loadBoardItem}
                            isOpen={open}
                            withTimestamps={false}
                            counterPanel={
                                isCountered ? <LoadCounterOfferPanel offer={offer} onDone={() => onOpenChange(false)} /> : undefined
                            }
                        />
                    </TableBody>
                </Table>
            </div>
        </LoadboardModal>
    );
};
